module.exports = __webpack_public_path__ + "img/info_icon.00a370cb.svg";